<script  setup>

import axios from "axios";
import {computed, reactive, ref, watch} from "vue";
import {ElButton, ElCard, ElCol, ElRow, ElText, FormInstance} from "element-plus";
import {Delete} from "@element-plus/icons-vue";
import { moneyTotal, formatMoney, roundMoney } from '../../../utils/money';

const props = defineProps({
    tranfer:Object,
    form:Object,
    itninery:Object,
    index: Number

});

const ruleFormRef = ref()
let tranfer=props.tranfer;
const eform=props.form;
const itineries=props.itninery;
const index=props.index;
const editprice=ref(false);

const editform=reactive(
    {
        "type":tranfer.type,
        "vechile":tranfer.vechile,
        "pointslist":JSON.parse(JSON.stringify(tranfer.pointslist)),
        "pricing":{
            "total":tranfer.pricing.total,
            "adult":tranfer.pricing.adult ,
            "child":tranfer.pricing.child ,
            "infant":tranfer.pricing.infant ,
        }
    }
)

const removetranfer=(tranfer)=>{
    itineries.transfers.splice(index,1);
}


const refreshprice = () => {
    editform.type=tranfer.type;
    editform.vechile=tranfer.vechile;
    editform.pointslist=JSON.parse(JSON.stringify(tranfer.pointslist));
    editform.pricing.total=tranfer.pricing.total;
    editform.pricing.adult=tranfer.pricing.adult;
    if(eform.childs>0){
        editform.pricing.child=tranfer.pricing.child;
    }
    if(eform.infants>0){
        editform.pricing.infant=tranfer.pricing.infant;
    }


};

watch(
    () => editform.pricing,
    () => {
        updateupricecount();
    },
    { deep: true }
)

const updateupricecount = () => {
    editform.pricing.total = moneyTotal(eform.adults, editform.pricing.adult, eform.childs, editform.pricing.child, eform.infants, editform.pricing.infant);
};

const savePrice = () => {
    let tprice={
        total:0,
        adult:0,
        infant:0,
        child:0
    };
    tprice.adult=roundMoney(editform.pricing.adult);
    tprice.child=eform.childs>0 ? roundMoney(editform.pricing.child) : 0;
    tprice.infant=eform.infants>0 ? roundMoney(editform.pricing.infant) : 0;
    tprice.total=moneyTotal(eform.adults, tprice.adult, eform.childs, tprice.child, eform.infants, tprice.infant);
    tranfer.pricing=tprice;

    tranfer.type=editform.type;
    tranfer.vechile=editform.vechile;
    tranfer.pointslist=JSON.parse(JSON.stringify(editform.pointslist));
    editprice.value=false;


};

const submitForm = async (formEl) => {

    if (!formEl) return
    await formEl.validate((valid, fields) => {

        if (valid) {

            savePrice()

        }
    })
}

const removepoint = (index) => {


    editform.pointslist.splice(index, 1)

}
const addpoint = () => {


    editform.pointslist.push("");


}

const transfertypes=ref(
    [
        "Shared",
        "Private"
    ]
)

const vechilestypes=ref(
    [
        "Sedan",
        "SUV",
        "Eeco",
    ]
)
</script>

<template>
    <el-card class="mb-3"  shadow="never" :body-style="{padding:0}">
        <div class="flex">

            <div class="p-2" style="width: 100%;">
                <div>
                    <el-tag  type="success">
                        <b>{{ tranfer.type }}</b>
                    </el-tag>
                    <el-tag class="ml-2" v-if="tranfer.vechile"  type="success">
                        <b>{{ tranfer.vechile }}</b>
                    </el-tag>
                    <el-tag class="ml-2"  v-for="(point,index) in tranfer.pointslist"   type="primary">
                        <b>{{ point }}</b>
                    </el-tag>

                </div>



            </div>
            <div class="p-2">
                <div class="flex">
                    <el-dropdown trigger="hover">
                        <div>
                            <el-text tag="b" size="large">₹{{ formatMoney(tranfer.pricing.total) }} </el-text>
                            <el-text class="ml-2" tag="b" size="small" type="info"  @click="refreshprice();editprice=true">Edit</el-text>
                        </div>
                        <template #dropdown>

                            <p >
                                Adult - ₹  {{formatMoney(tranfer.pricing.adult)}}
                            </p>
                            <p v-if="tranfer.pricing.child!=null">
                                Child - ₹  {{formatMoney(tranfer.pricing.child)}}
                            </p>
                            <p v-if="tranfer.pricing.infant!=null">
                                Infant - ₹  {{formatMoney(tranfer.pricing.infant)}}
                            </p>

                        </template>
                    </el-dropdown>

                    <el-button class="ml-2" type="danger" size="small" @click="removetranfer(tranfer)" >Remove</el-button>
                </div>
                <div>

                </div>




            </div>
        </div>


    </el-card>

    <el-dialog
        v-model="editprice"
        title="Edit Pricing"
        width="80%"

    >
        <el-form
            ref="ruleFormRef"
            :model="editform"
            status-icon
            label-width="auto"
            class="demo-ruleForm"
            label-position="top"
            size="small"

        >
          <el-row :gutter="20">
              <el-col :span="12">
                  <el-row :gutter="10">
                      <el-col :span="12">

                          <el-form-item
                              class="mt-3"
                              prop="type"
                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }"
                          >

                              <el-select
                                  v-model="editform.type"
                                  placeholder="Choose Transfer Type"
                                  style="width: 100%"

                              >
                                  <el-option
                                      v-for="item in transfertypes"
                                      :key="item"
                                      :label="item"
                                      :value="item"
                                  />
                              </el-select>

                          </el-form-item>
                      </el-col>
                      <el-col :span="12">

                          <el-form-item
                              class="mt-3"
                              prop="vechile"

                          >

                              <el-select
                                  filterable
                                  allow-create
                                  clearable
                                  v-model="editform.vechile"
                                  placeholder="Choose Vechile Type"
                                  style="width: 100%"

                              >
                                  <el-option
                                      v-for="item in vechilestypes"
                                      :key="item"
                                      :label="item"
                                      :value="item"
                                  />
                              </el-select>

                          </el-form-item>
                      </el-col>

                      <el-col :span="24">
                          <el-form-item
                              v-for="(ttr,index2) in editform.pointslist"
                              :prop="'pointslist['+index2+']'"
                              :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }"
                              :key="index2"
                          >


                              <el-input
                                  v-model="editform.pointslist[index2]"
                                  placeholder="Enter Destination"
                              >
                                  <template #append><el-button v-if="editform.pointslist.length>2" type="danger" @click="removepoint(index2)"><Delete style="width: 1em; height: 1em; margin-right: 8px" /></el-button></template>
                              </el-input>


                          </el-form-item>
                          <el-button @click="addpoint()" class="mb-2" size="small" >Add</el-button>

                      </el-col>
                  </el-row>
              </el-col>
              <el-col :span="12">
                  <el-row :gutter="20">
                      <el-col :span="8" >
                          <el-form-item label="Adults" >
                              <el-input v-model="eform.adults"  placeholder="Adults" readonly/>
                          </el-form-item>

                      </el-col>
                      <el-col :span="8" >
                          <el-form-item label="Adult Pricing" prop="pricing.adult" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                              <el-input v-model="editform.pricing.adult"  placeholder="Adult Pricing" type="number" />
                          </el-form-item>

                      </el-col>


                  </el-row>
                  <el-row :gutter="20" v-if="eform.childs>0">
                      <el-col :span="8" >
                          <el-form-item label="Child" >
                              <el-input v-model="eform.childs"  placeholder="Child" readonly/>
                          </el-form-item>

                      </el-col>
                      <el-col :span="8" >
                          <el-form-item label="Child Pricing" prop="pricing.child" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                              <el-input v-model="editform.pricing.child"  placeholder="Child Pricing"  type="number" />
                          </el-form-item>

                      </el-col>


                  </el-row>
                  <el-row :gutter="20" v-if="eform.infants>0">
                      <el-col :span="8" >
                          <el-form-item label="Infants" >
                              <el-input v-model="eform.infants"  placeholder="Infants" readonly/>
                          </el-form-item>

                      </el-col>
                      <el-col :span="8" >
                          <el-form-item label="Infants Pricing" prop="pricing.infant" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                              <el-input v-model="editform.pricing.infant"  placeholder="Infants Pricing"  type="number"/>
                          </el-form-item>

                      </el-col>


                  </el-row>
                  <el-row :gutter="20" >
                      <el-col :span="8" >


                      </el-col>
                      <el-col :span="8" >
                          <el-form-item label="Total Pricing" prop="pricing.total" :rules="{
                                                        required: true,
                                                        message: 'Required',
                                                        trigger: ['blur','change'],
                                                      }">
                              <el-input v-model="editform.pricing.total"  placeholder="Total Pricing"  type="number" readonly/>
                          </el-form-item>

                      </el-col>


                  </el-row>
              </el-col>
          </el-row>


        </el-form>


        <template #footer>
            <div class="dialog-footer">
                <el-button @click="editprice = false">Cancel</el-button>
                <el-button type="primary" @click="submitForm(ruleFormRef)">
                    Save
                </el-button>
            </div>
        </template>

    </el-dialog>
</template>

<style scoped>

</style>
